import { TestimonialSource, type Testimonial } from './types';

const AVATAR_1 = '/assets/images/avatar/customer-avatar1.jpg';
const AVATAR_2 = '/assets/images/avatar/customer-avatar2.jpg';
const AVATAR_3 = '/assets/images/avatar/customer-avatar3.jpg';
const AVATAR_4 = '/assets/images/avatar/customer-avatar4.jpg';
const COMPANY_LOGO = '/assets/images/ark-logo.svg';

export const TESTIMONIALS: Testimonial[] = [
  {
    id: 'li-1',
    source: TestimonialSource.LINKEDIN,
    name: 'Felix Frank',
    role: 'Founder, Stack',
    company: 'Stack',
    avatar: AVATAR_1,
    logo: COMPANY_LOGO,
    quote:
      'A major bottleneck in scaling from 30k to higher revenue was finding qualified leads fast enough. AI ARK changed that — we now run outbound at a pace that used to be impossible.',
    url: 'https://www.linkedin.com/',
  },
  {
    id: 'li-2',
    source: TestimonialSource.LINKEDIN,
    name: 'Penn Frank',
    role: 'Growth Operator',
    company: 'AI ARK Customer',
    avatar: AVATAR_2,
    logo: COMPANY_LOGO,
    quote:
      'A big fat shout out to AI ARK — the biggest unlock for our outbound this year. The data quality and speed are unmatched.',
    url: 'https://www.linkedin.com/',
  },
  {
    id: 'li-3',
    source: TestimonialSource.LINKEDIN,
    name: 'Cristian Nobile',
    role: 'Sales Lead, Forma',
    company: 'Forma',
    avatar: AVATAR_3,
    logo: COMPANY_LOGO,
    quote:
      'AI ARK helped me create much more functional outbound flows for my customers due to the increased speed and freedom in the UI.',
    url: 'https://www.linkedin.com/',
  },
  {
    id: 'li-4',
    source: TestimonialSource.LINKEDIN,
    name: 'Timothy Upai Lindris',
    role: 'Head of Growth, Vanta',
    company: 'Vanta',
    avatar: AVATAR_4,
    logo: COMPANY_LOGO,
    quote:
      'My experience with AI ARK has been nothing short of exceptional. It has elevated my outbound process, empowered collaboration, and helped me deliver outstanding results.',
    url: 'https://www.linkedin.com/',
  },
  {
    id: 'li-5',
    source: TestimonialSource.LINKEDIN,
    name: 'Melody O.',
    role: 'Designer, Loop',
    company: 'Loop',
    avatar: AVATAR_1,
    logo: COMPANY_LOGO,
    quote:
      "AI ARK is more than just a sales tool — it's a complete ecosystem that revolutionizes prospecting.",
    url: 'https://www.linkedin.com/',
  },

  {
    id: 'yt-1',
    source: TestimonialSource.YOUTUBE,
    videoId: 'dbE0yZx81lQ',
    channel: 'Growth Stack',
    title: 'Why we replaced 4 tools with AI ARK',
    duration: '8:42',
    views: '12K',
  },
  {
    id: 'yt-2',
    source: TestimonialSource.YOUTUBE,
    videoId: '4NWJfNSmUBw',
    channel: 'SaaS Reviewed',
    title: 'AI ARK honest review after 90 days',
    duration: '14:05',
    views: '38K',
  },
  {
    id: 'yt-3',
    source: TestimonialSource.YOUTUBE,
    videoId: 'FSJZSpIpNew',
    start: 203,
    channel: 'Outbound Daily',
    title: 'AI ARK walkthrough',
    duration: '10:24',
    views: '8.1K',
  },
  {
    id: 'yt-4',
    source: TestimonialSource.YOUTUBE,
    videoId: '_WdOtvILz5M',
    channel: 'AI ARK',
    title: 'AI ARK demo',
    duration: '7:12',
    views: '4.6K',
  },
  {
    id: 'yt-5',
    source: TestimonialSource.YOUTUBE,
    videoId: '3rdKBHzfJXY',
    start: 23,
    channel: 'AI ARK',
    title: 'AI ARK in action',
    duration: '5:48',
    views: '3.2K',
  },

  {
    id: 'ld-1',
    source: TestimonialSource.LEADER,
    name: 'Thibault Garcia',
    role: 'Founder',
    company: 'Reachly',
    headline: 'TAM faster. Fewer workflows.',
    avatar: AVATAR_2,
    logo: COMPANY_LOGO,
    quote:
      "Since using AI ARK, pulling leads for specific accounts has become much easier and we've been able to cut a lot of the workflows we previously relied on to build our client's TAM.",
    url: 'https://www.linkedin.com/',
  },
  {
    id: 'ld-2',
    source: TestimonialSource.LEADER,
    name: 'Xavier Caffrey',
    role: 'Founder-CEO',
    company: 'Oneaway',
    headline: 'More Leads, Faster',
    avatar: AVATAR_3,
    logo: COMPANY_LOGO,
    quote:
      'AI ARK helps us find 20–30% more leads than other databases, with genuinely up-to-date data refreshed every 30 days. The lookalike filter is best-in-class.',
    url: 'https://www.linkedin.com/',
  },
  {
    id: 'ld-3',
    source: TestimonialSource.LEADER,
    name: 'Mitchell Keller',
    role: 'Co-Founder & Head of Growth',
    company: 'LeadGrow.ai',
    headline: '10/10 tests. No contest.',
    avatar: AVATAR_4,
    logo: COMPANY_LOGO,
    quote:
      'I ran a line-by-line comparison between competitors and AI ARK, and AI ARK won 10 out of 10 tests. It consistently surfaced more complete, usable contact records than anyone else we tried.',
    url: 'https://www.linkedin.com/',
  },
  {
    id: 'ld-4',
    source: TestimonialSource.LEADER,
    name: 'Penn Frank',
    role: 'Co-Founder',
    company: 'StackOptimise',
    headline: 'Speed Meets Data Quality',
    avatar: AVATAR_1,
    logo: COMPANY_LOGO,
    quote:
      'AI ARK has accelerated our high-volume lead exports, delivering deeper enrichment at scale without sacrificing data quality.',
    url: 'https://www.linkedin.com/',
  },
  {
    id: 'ld-5',
    source: TestimonialSource.LEADER,
    name: 'Alex Fine',
    role: 'Co-Founder',
    company: 'Understory',
    headline: 'Replaced our old stack. Scale unlocked.',
    avatar: AVATAR_2,
    logo: COMPANY_LOGO,
    quote:
      "AI ARK has become a key part of our tech stack. We're confident bounce rates stay under 1% without any separate validation step. Exporting 100k leads is effortless, fast, and reliable.",
    url: 'https://www.linkedin.com/',
  },
  {
    id: 'ld-6',
    source: TestimonialSource.LEADER,
    name: 'Javeria Shah',
    role: 'Co-Founder & CTO',
    company: 'DFY Automation',
    headline: 'Cleaner Matches, Better Leads',
    avatar: AVATAR_3,
    logo: COMPANY_LOGO,
    quote:
      "AI ARK's company-profile support has been a game-changer, eliminating domain mismatches and improving the accuracy of the people data we pull for outreach.",
    url: 'https://www.linkedin.com/',
  },
  {
    id: 'ld-7',
    source: TestimonialSource.LEADER,
    name: 'Dan Rosenthal',
    role: 'Co-Founder',
    company: 'Workflows.io',
    headline: 'Bulk Data, Reliable',
    avatar: AVATAR_4,
    logo: COMPANY_LOGO,
    quote:
      'AI ARK is our go-to B2B database for bulk exports across TAM mapping, stakeholder mapping, and outbound list-building.',
    url: 'https://www.linkedin.com/',
  },
  {
    id: 'ld-8',
    source: TestimonialSource.LEADER,
    name: 'Taylor Haren',
    role: 'Founder',
    company: 'Sales Automation',
    headline: 'Our #1 source of positive replies.',
    avatar: AVATAR_1,
    logo: COMPANY_LOGO,
    quote:
      "AI ARK became our #1 source of positive replies. The intent and fit were so strong we'd need 10× more leads elsewhere to match the same number of positive responses.",
    url: 'https://www.linkedin.com/',
  },
];
